"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var click_outside_directive_1 = require("./click-outside.directive");
var ClickOutsideModule = /** @class */ (function () {
    function ClickOutsideModule() {
    }
    ClickOutsideModule = __decorate([
        core_1.NgModule({
            declarations: [click_outside_directive_1.ClickOutsideDirective],
            exports: [click_outside_directive_1.ClickOutsideDirective]
        })
    ], ClickOutsideModule);
    return ClickOutsideModule;
}());
exports.ClickOutsideModule = ClickOutsideModule;



//////////////////
// WEBPACK FOOTER
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/node_modules/ng-click-outside/lib/click-outside.module.js
// module id = ../../../../ng-click-outside/lib/click-outside.module.js
// module chunks = employment-application.module